import { Level } from '@/store/candidate.store';

export const levels: Level[] = [
  {
    id: 1,
    label: 'Introduction',
    timeRecord: 20,
    videoRecord: null,
    isPassed: false,
    isActive: false,
    recordChunksLevel: undefined,
    setRecordChunksLevel: undefined,
  },
  {
    id: 2,
    label: 'Qualifications',
    timeRecord: 20,
    videoRecord: null,
    isPassed: false,
    isActive: false,
    recordChunksLevel: undefined,
    setRecordChunksLevel: undefined,
  },
  {
    id: 3,
    label: 'Expériences',
    timeRecord: 20,
    videoRecord: null,
    isPassed: false,
    isActive: false,
    recordChunksLevel: undefined,
    setRecordChunksLevel: undefined,
  },
];
export const BackendUrl = process.env.REACT_APP_BACKEND_URI_CV;
